import { useCallback } from 'react';
import { useParams } from 'react-router';
import { OrgEmployeeService } from 'src/api/OrgEmployeeService';
import { invalidateEmployee, invalidateEmployees } from '@stores/employeeStore';
import { invalidateOrgEmployeeData } from '@stores/orgEmployeeStore';

type DeleteEmployeeLink = (
    orgId: string,
    orgEmployeeId: string,
    employeeId: string,
) => Promise<true>;

const useDeleteEmployeeLink = (): {
    deleteEmployeeLink: DeleteEmployeeLink;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const deleteEmployeeLink = useCallback<DeleteEmployeeLink>(
        async (
            orgId: string,
            orgEmployeeId: string,
            employeeId: string,
        ): Promise<true> => {
            if (!departmentId) {
                throw new Error(
                    'useDeleteEmployeeLink requires a departmentId route param',
                );
            }

            const isEmployeeLinkDeleted =
                await OrgEmployeeService.deleteEmployeeLink(
                    orgId,
                    orgEmployeeId,
                    employeeId,
                );

            invalidateEmployee(departmentId, employeeId);
            invalidateEmployees(departmentId);
            invalidateOrgEmployeeData();

            return isEmployeeLinkDeleted;
        },
        [departmentId],
    );

    return { deleteEmployeeLink };
};

export default useDeleteEmployeeLink;
